export default __webpack_public_path__ + "static/media/biboo2.ef6ffb6b.png";